import React, { useEffect } from "react";

export default function Hidden(props) {
    const { type, input: { value, onChange, name }, defaultValue = "" } = props;

    useEffect(() => {
        if (defaultValue) {
            onChange(defaultValue);
        }
    }, [defaultValue]);

    return (
        <input
            type={type}
            value={value}
            onChange={onChange}
            name={name}
        />
    )
}